var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlpha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.165,
    height: 27.162,
    "data-name": "Group 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.353 26.908a1.708 1.708 0 01-2.348-.558 91.333 91.333 0 00-5.275-7.229 31.782 31.782 0 002.016-2.886 91.941 91.941 0 016.166 8.325 1.707 1.707 0 01-.559 2.348z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.207 11.828c.495-.982 1.123-2.5 1.5-3.425a1.708 1.708 0 00-3.174-1.259 45.381 45.381 0 01-5.488 10.035c-2.992 4.646-11.01 10.307-14.339 3.162-1.713-3.447-1.588-8.435.273-10.891 3.815-4.178 10.178 1.158 14.239 4.784a31.363 31.363 0 001.712-3.074C-1.639-9.985-6.701 25.748 9.379 27.16c5.25-.034 9.419-3.964 12.387-7.929a46.83 46.83 0 004.438-7.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.315 1.787A1.787 1.787 0 1128.528 0a1.787 1.787 0 011.787 1.787z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpha);
export default __webpack_public_path__ + "static/media/alpha.29c4868937e1ebc248135baeaedf4dd5.svg";
export { ForwardRef as ReactComponent };